import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectBuildingTypeFilter } from 'shared/selectors/advancedFilters';
import { EBuildingType } from '../../../../../../../packages/JsonQuery/types/buildingType';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { UI_TO_LEGACY_BUILDING_TYPE } from '../../../../../../../packages/JsonQuery/utils/mapBuildingType';

export const BuildingTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectBuildingTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleBuildingTypeChange = useCallback(
    (newValue: NonEmptyArray<EBuildingType> | null) => {
      const legacy = newValue ? newValue.map(v => UI_TO_LEGACY_BUILDING_TYPE[v]) : null;

      onChange({ action: 'setBuildingType', arguments: [legacy] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleBuildingTypeChange} />
    </AdvancedFilterRow>
  );
};
